import React from 'react';
import { Image, StyleSheet, View } from 'react-native';
import PropTypes from 'prop-types';
import { getProgressColor } from '../utilities/colorutils';
import Text from '../../design/components/Text';

class SeverityCircle extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const color = getProgressColor(this.props.value, this.props.mode);
    const severity = Math.round(this.props.value / 10);
    const size = this.props.size || 50;
    const border = size / 2;
    let starImage = require('../../modules/Records/assets/star.png');

    return (
      <View
        style={[
          styles.severityBox,
          {
            backgroundColor:
              this.props.mode === 'DailyReflection' ? '#00000000' : color,
          },
          {
            width: size,
            height: size,
            borderRadius: border,
          },
          { ...this.props.style },
        ]}
      >
        {this.props.mode === 'DailyReflection' && (
          <Image
            style={{
              zIndex: 0,
              tintColor: color,
              height: size,
              width: size,
              alignSelf: 'center',
              position: 'absolute',
              resizeMode: 'contain',
            }}
            source={starImage}
          />
        )}
        <Text
          black
          style={[styles.severityText, { fontSize: size / 2.5, zIndex: 1 }]}
        >
          {severity}
        </Text>
      </View>
    );
  }
}

SeverityCircle.propTypes = {
  value: PropTypes.number.isRequired,
  mode: PropTypes.oneOf(['DailyReflection', 'PainRecord', 'severity'])
    .isRequired,
  size: PropTypes.number,
};
SeverityCircle.defaultProps = {
  value: 0,
};

const styles = StyleSheet.create({
  severityBox: {
    justifyContent: 'center',
    alignSelf: 'center',
    alignItems: 'center',
  },
  severityText: {
    alignSelf: 'center',
    textAlign: 'center',
    textAlignVertical: 'center',
  },
});
export default SeverityCircle;
